import { Box, HStack, Text } from "@chakra-ui/react";
import React from "react";
import { ClassificationTagBox } from "./ClassificationTagBox";

interface ClassificationsGroupType {
  classification: string | null;
  // originalUrl: UrlClassificationType;
  classicationType?: "Accepted" | "Rejected" | "Original";
  [key: string]: any; 
}

export const ClassificationsGroup = ({
  classification,
  classicationType,
  ...rest
}: ClassificationsGroupType) => {
  let classificationCategories: Record<string, any> = {};

  // switch (classicationType) {
  //   case "Accepted":
  //     fontColor = chakraTheme.colors.submitGreen.default;
  //     break;
  //   case "Rejected":
  //     fontColor = chakraTheme.colors.cancelRed.default;
  //     break;
  // }

  if (!classification || classification === null) {
    return <></>;
  } else {
    try {
      classificationCategories = JSON.parse(classification);
      
      
    } catch {
      return <></>;
    }
  }

  let categories;

  try {
    categories = Object.entries(classificationCategories);
    

  } catch {
    return <></>
  }

  const midIndex = Math.ceil(categories.length / 2);

    const firstCategories = categories.slice(0, midIndex);
    const secondCategories = categories.slice(midIndex);

    const classificationCategoriesCol1 = Object.fromEntries(firstCategories);
    const classificationCategoriesCol2 = Object.fromEntries(secondCategories);
  
  return (
    <Box w={"100%"}>
      {classicationType && (
        <Text
          width={"100%"}
          fontSize={"18px"}
          fontWeight={"medium"}
          color={"black"}
        >
          {`${classicationType} Classifications`}
        </Text>
      )}

      <HStack spacing={3} w="100%" align="flex-start">
        <Box flex="1" w={"100%"}>
          {Object.entries(classificationCategoriesCol1).map(
            (entries: any, ix: number) => (
              <ClassificationTagBox
                key={ix}
                classificationEntries={entries}
                ix={ix}
                {...rest}
              />
            )
          )}
        </Box>
        {classificationCategoriesCol1 !== classificationCategoriesCol2 && (
          <Box flex="1" w={"100%"}>
            {Object.entries(classificationCategoriesCol2).map(
              (entries: any, ix: number) => (
                <ClassificationTagBox
                  key={ix}
                  classificationEntries={entries}
                  ix={ix}
                  {...rest}
                />
              )
            )}
          </Box>
        )}
      </HStack>
    </Box>
  );
};
